import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class UpdateAISummaryInDisputeCommentsByRecordingUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (record: string, params: any): Promise<any> => {
        return await this._aiRepository.UpdateAISummaryInDisputeCommentsByRecord(record, params);
    }
}

export const UpdateAISummaryInDisputeCommentsByRecordingUseCaseName = "UpdateAISummaryInDisputeCommentsByRecordingUseCaseName";